import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../../../Components/Buttons/CustomButton';
import DrawerIndustryBreakdownTable from './DrawerIndustryBreakdownTable';
import { INDUSTRY_BREAKDOWN_TABLE_TITLE } from '../../const';

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        width: 'auto',

        [theme.breakpoints.up('md')]: {
            width: '50%',
        },

        [theme.breakpoints.up('lg')]: {
            width: '30%',
        },
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(1),
        padding: theme.spacing(0.5),
        minWidth: 0,
        borderRadius: theme.spacing(0.5),
    },
    closeIcon: {
        fontSize: theme.spacing(2),
        color: 'gray',
    },
    drawerTitle: {
        fontSize: theme.spacing(2.2),
        color: theme.palette.primary.main,
        fontWeight: 600,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(3),
    },
    drawerContainer: {
        padding: `0 ${theme.spacing(4)}px`,
        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(4.2)
        },
    },
    helpdocLink: {
        textDecoration: 'none',
        color: theme.palette.tertiary.main,
        fontWeight: 700
    },
    helpdocLinkContainer: {
        paddingTop: theme.spacing(4)
    },
    drawerTable: {
        paddingTop: theme.spacing(4),
    },
    drawerSubtitle: {
        fontSize: theme.spacing(2),
        color: theme.palette.primary.main,
        fontWeight: 600,
        margin: 0,
    },
    clientAnswersButton: {
        fontWeight: 'bold',
        borderRadius: '0.5rem',
    },
}))

const InsightsDrawer = ({ title, drawerOpened, toggleDrawer, helpdocLink, insightsDrawerButtonLink, industryBreakdown, reviewCount }) => {
    const classes = useStyles()

    const shouldShowIndustryBreakdown = industryBreakdown && industryBreakdown.length > 0 && reviewCount && reviewCount >= 30

    return (
        <Drawer
            anchor="right"
            open={drawerOpened}
            onClose={toggleDrawer}
            classes={{ paper: classes.drawerPaper }}
        >
            <IconButton onClick={toggleDrawer} className={classes.closeButton}>
                <CloseIcon className={classes.closeIcon}/>
            </IconButton>
            <div className={classes.drawerContainer}>
                <Typography className={classes.drawerTitle}>{title}</Typography>
                {insightsDrawerButtonLink &&
                    <div>
                        <Button color="tertiary" variant="contained" className={classes.clientAnswersButton} href={insightsDrawerButtonLink}>
                            View client answers
                        </Button>
                    </div>
                }
                {shouldShowIndustryBreakdown &&
                    <div className={classes.drawerTable}>
                        <Typography className={classes.drawerSubtitle}>{INDUSTRY_BREAKDOWN_TABLE_TITLE}</Typography>
                        <DrawerIndustryBreakdownTable industryBreakdown={industryBreakdown}/>
                    </div>
                }
                <div className={classes.helpdocLinkContainer}>
                    {helpdocLink !== null &&
                        <a data-test='helpdoc-link' className={classes.helpdocLink} href={helpdocLink} rel='noreferrer'
                           target='_blank'>Learn how to improve your score</a>}
                </div>
            </div>
        </Drawer>
    )
}

export default (InsightsDrawer)